// extracted by mini-css-extract-plugin
export var actionText = "_of-4";
export var container = "_of-0";
export var leftSection = "_of-1";
export var rightSection = "_of-2";
export var settingsButton = "_of-6";
export var settingsIcon = "_of-7";
export var shortcut = "_of-5";
export var shortcutGroup = "_of-3";